import { FC, useEffect, useState } from "react";

import {
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedMultiDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";
import { useNavigateToLogout } from "../../../common/Common";
import { CountryService } from "../../../services/common/CountryService";
import { SelectAllOrRemoveAllProvinces } from "../../CommonComponents/SelectAllOrRemoveAllProvinces";

interface IStatutoryHolidayInfoSetupFieldsPanel {
	countryList: any;
	provinceDDLItems: (value: any) => void;
	formMethods: any;
}
export const StatutoryHolidayInfoSetupFieldsPanel: FC<
	IStatutoryHolidayInfoSetupFieldsPanel
> = ({ countryList, provinceDDLItems , formMethods}) => {
	const [provinceDDL, setprovinceDDL] = useState([]);
	const navigateToLogout = useNavigateToLogout();

	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setprovinceDDL(response);
						provinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			}
		}
	}, [countryList]);
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="Holiday"
				id="holidayLabel"
				testId={`holidayLabel`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormDatePicker
				name="holidayDate"
				testId="holidayDate"
				label="Holiday Date"
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedMultiDropDownRHFWithLabel
				selectName="province"
				items={provinceDDL}
				testId="province"
				label="Provinces"
			/>
			<SelectAllOrRemoveAllProvinces formMethods={formMethods} provinceDDL={provinceDDL} />
			<EnhancedCheckboxRHF
				name="regularHoliday"
				checked={false}
				testId="regular-holiday`"
				id="regularHoliday"
				// labelPosition={LabelPosition.Top}
				checkboxLabel={"Regular Holiday"}
			/>
			<EnhancedCheckboxRHF
				name="continuousOperation"
				checked={false}
				testId="continuous-operation`"
				id="continuousOperation"
				// labelPosition={LabelPosition.Top}
				checkboxLabel={"Continuous Operation"}
			/>
			<EnhancedCheckboxRHF
				name="bankHoliday"
				checked={false}
				testId="bank-holiday`"
				id="bankHoliday"
				// labelPosition={LabelPosition.Top}
				checkboxLabel={"Bank Holiday"}
			/>
			<EnhancedCheckboxRHF
				name="optionalHoliday"
				checked={false}
				testId="optional-holiday`"
				id="optionalHoliday"
				// labelPosition={LabelPosition.Top}
				checkboxLabel={"Optional Holiday"}
			/>
		</Box>
	);
};
